import { FinancialAccount } from '@/reducers/finances/financialAccountsReducer'
import { TypographyStyles } from '@/styles'
import { Card, CardColors, Text } from '@/ui'

export interface AccountBannerProps {
  account: FinancialAccount
  type: 'hide' | 'show'
}

export const AccountBannerCard = ({ account, type }: AccountBannerProps) => {
  const isHidden = type === 'hide'
  const cardColor = isHidden ? CardColors.LEVEL_0 : CardColors.SUCCESS

  return (
    <Card color={cardColor}>
      <Text variant={TypographyStyles.H2}>
        Account {type === 'hide' ? 'Hidden' : 'Visible'}
      </Text>

      <Text>
        {account.name} - {account.mask}
        {type === 'hide'
          ? ' has been hidden. Transactions will be hidden in Heard.'
          : ' is now visible. Transactions will now be visible in Heard.'}
      </Text>
    </Card>
  )
}
